import type { BusinessFeeBannerContent, LinkItem } from '~/content/types';
import { ButtonLink, Icon } from '~/components/ui';
import { cn } from '~/lib/cn';

/** Fee and waitlist strip under the business hero (Figma 1469:26820). */
export function BusinessFeeBanner({
  content,
  className,
}: {
  content: BusinessFeeBannerContent;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'flex items-center gap-6 border-y border-grey-100 py-6 md:min-h-16 md:gap-[23px] md:px-5 md:py-4',
        className,
      )}>
      <Icon name={content.icon} className="size-6 shrink-0" />
      <p className="flex-1 text-[12px] leading-[1.32] tracking-[-0.024px] text-grey-900 md:text-body md:text-black">
        {content.text} <BannerLink link={content.termsLink} /> {content.waitlistText}{' '}
        <BannerLink link={content.waitlistLink} />
      </p>
    </div>
  );
}

function BannerLink({ link }: { link: LinkItem }) {
  return (
    <ButtonLink
      href={link.href}
      external={link.external}
      variant="ghost"
      size="md"
      className="!inline min-w-0 !p-0 !text-[length:inherit] !leading-[inherit] !tracking-[inherit] !font-normal !text-red-500 hover:!bg-transparent hover:!text-red-700">
      {link.label}
    </ButtonLink>
  );
}
